// @flow

import React from 'react';
import Cropper from 'react-easy-crop';
import { useSelector, useDispatch } from 'react-redux';
import { closeModal, zoomImage, cropImage, completeCropping, renderImage } from './actions';


function CropTool() {
  const imageSrc = useSelector(state => state.imageSrc);
  const crop = useSelector(state => state.crop);
  const zoom = useSelector(state => state.zoom);
  const pixels = useSelector(state => state.pixels);
  const dispatch = useDispatch();


  const createImage = url => {
    return new Promise((resolve, reject) => {
      const image = new Image()
      image.addEventListener('load', () => resolve(image))
      image.addEventListener('error', error => reject(error))
      image.src = url
    })
  }

  const drawImage = async (e) => {
    e.preventDefault();
    const canvas = document.createElement('canvas');
    canvas.width = pixels.width
    canvas.height = pixels.height
    const ctx = canvas.getContext('2d')
    const image = await createImage(imageSrc);
    ctx.drawImage(
      image,
      pixels.x,
      pixels.y,
      pixels.width,
      pixels.height,
      0,
      0,
      pixels.width,
      pixels.height
    )
    dispatch(renderImage(canvas.toDataURL('image/jpeg')));
  }

  return (
    <div className="rows">
      <h1 className="heading font-xl u-centered row row--fixed">
        Zoom in op het gezicht van de jarige!<br />
        Zorg dat de afbeelding recht in beeld staat en niet gekanteld is.
      </h1>
      <div className="row u-margin-top">
        <div className="crop-container">
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={1}
            onCropChange={(coordinates) => dispatch(cropImage(coordinates))}
            onCropComplete={(_c, coordinates) => dispatch(completeCropping(coordinates))}
            onZoomChange={(level) => dispatch(zoomImage(level))}
          />
        </div>
        <div className="slider">
          <input
            type="range"
            min={1}
            max={1.5}
            value={zoom}
            step={0.1}
            onChange={(e) => dispatch(zoomImage(e.target.value))}
            aria-labelledby="Zoom"
            style={ {width: "100%"} }
            className="slider__control"
          />
        </div>
      </div>
      <div className="u-centered row row--fixed">
        <button className="btn" onClick={drawImage}>Oké</button>
        <span className="u-padded"></span>
        <button className="btn btn--secondary" onClick={(e) => { e.preventDefault(); dispatch(closeModal()) } }>Annuleren</button>
      </div>
    </div>
  )
}

export default CropTool;
